import { Subject } from 'interfaces/Subject'

export const formatSubjectLabel = (subject: Subject) =>
    `${subject.name} - ${subject.language?.englishName ?? subject?.countryCode} 
    ${subject?.examType && subject.examType.name !== 'DEFAULT' ? `(${subject.examType.name})` : ''}`
